// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingBlockApprovalRequest } from "./bidding_block_model_pb";
import { file_bffuser_v1_bidding_block_model } from "./bidding_block_model_pb";
import type { BiddingApprovalMode, BiddingBulkApprovalApproved, BiddingBulkApprovalFailureReason, BiddingBulkApprovalTarget, BiddingBulkWithdrawAccepted, BiddingBulkWithdrawFailure, BiddingBulkWithdrawTarget, BiddingLifecycleAction } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { BiddingExecutionResultLine, BiddingExecutionResultStatusSelection, BiddingExecutionResultWorkflowSelection } from "./bidding_execution_result_model_pb";
import { file_bffuser_v1_bidding_execution_result_model } from "./bidding_execution_result_model_pb";
import type { BiddingSpotApprovalRequest, BiddingSpotApprovalRequestListItem, BiddingSpotBidInput, BiddingSpotCsvDateCount, BiddingSpotCsvRowResult, BiddingSpotDesiredPriceQuery, BiddingSpotDesiredPriceResult, BiddingSpotFeeAdjustedPriceQuery, BiddingSpotFeeAdjustedPriceResult, BiddingSpotFeeAutoConsiderState, BiddingSpotPendingApprovalDate, SpotBidWriteBlockedReason } from "./bidding_spot_model_pb";
import { file_bffuser_v1_bidding_spot_model } from "./bidding_spot_model_pb";
import type { BiddingSpotOperationLog } from "./bidding_spot_operation_log_model_pb";
import { file_bffuser_v1_bidding_spot_operation_log_model } from "./bidding_spot_operation_log_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_spot_service.proto.
 */
export const file_bffuser_v1_bidding_spot_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_bffuser_v1_bidding_block_model, file_bffuser_v1_bidding_common_model, file_bffuser_v1_bidding_execution_result_model, file_bffuser_v1_bidding_spot_model, file_bffuser_v1_bidding_spot_operation_log_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.GetBiddingSpotScreenRequest
 */
export type GetBiddingSpotScreenRequest = Message<"bffuser.v1.GetBiddingSpotScreenRequest"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetBiddingSpotScreenRequest.
 * Use `create(GetBiddingSpotScreenRequestSchema)` to create a new message.
 */
export const GetBiddingSpotScreenRequestSchema: GenMessage<GetBiddingSpotScreenRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 0);

/**
 * @generated from message bffuser.v1.GetBiddingSpotScreenResponse
 */
export type GetBiddingSpotScreenResponse = Message<"bffuser.v1.GetBiddingSpotScreenResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotApprovalRequest spot_approval_requests = 1;
   */
  spotApprovalRequests: BiddingSpotApprovalRequest[];

  /**
   * @generated from field: repeated bffuser.v1.BiddingBlockApprovalRequest block_approval_requests = 2;
   */
  blockApprovalRequests: BiddingBlockApprovalRequest[];

  /**
   * spot_approval_requests のデータ源取得結果。
   *
   * @generated from field: bffuser.v1.BiddingSpotScreenSourceStatus spot_status = 3;
   */
  spotStatus: BiddingSpotScreenSourceStatus;

  /**
   * block_approval_requests のデータ源取得結果。
   *
   * @generated from field: bffuser.v1.BiddingSpotScreenSourceStatus block_status = 4;
   */
  blockStatus: BiddingSpotScreenSourceStatus;

  /**
   * spot_approval_requests の札の workflow_id のうち、 業務ワークフローが確定済みのもの (AC-BSP-058)。
   * 一括取下の対象から外す札を画面が判定する。 スポットの取得に失敗した時 (spot_status が OK でない) は空。
   *
   * @generated from field: repeated string completed_workflow_ids = 5;
   */
  completedWorkflowIds: string[];

  /**
   * block_approval_requests のグループの workflow_id のうち、 一括取下がそのグループを受け付けないもの (確定済み
   * 〈AC-BSP-058〉か、 記録したワークフローのケースが見つからない。
   * internalapi.v1.ListBlockBidApprovalRequestDetailsResponse.bulk_withdraw_excluded_workflow_ids)。 一括取下の
   * 件数と対象から外すグループを画面が判定する。 ブロック入札の取得に失敗した時 (block_status が OK でない) は空。
   *
   * @generated from field: repeated string block_bulk_withdraw_excluded_workflow_ids = 6;
   */
  blockBulkWithdrawExcludedWorkflowIds: string[];
};

/**
 * Describes the message bffuser.v1.GetBiddingSpotScreenResponse.
 * Use `create(GetBiddingSpotScreenResponseSchema)` to create a new message.
 */
export const GetBiddingSpotScreenResponseSchema: GenMessage<GetBiddingSpotScreenResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 1);

/**
 * @generated from message bffuser.v1.ListBiddingSpotApprovalRequestsRequest
 */
export type ListBiddingSpotApprovalRequestsRequest = Message<"bffuser.v1.ListBiddingSpotApprovalRequestsRequest"> & {
  /**
   * @generated from field: optional google.type.Date target_date_filter = 1;
   */
  targetDateFilter?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotApprovalRequestsRequest.
 * Use `create(ListBiddingSpotApprovalRequestsRequestSchema)` to create a new message.
 */
export const ListBiddingSpotApprovalRequestsRequestSchema: GenMessage<ListBiddingSpotApprovalRequestsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 2);

/**
 * @generated from message bffuser.v1.ListBiddingSpotApprovalRequestsResponse
 */
export type ListBiddingSpotApprovalRequestsResponse = Message<"bffuser.v1.ListBiddingSpotApprovalRequestsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotApprovalRequestListItem items = 1;
   */
  items: BiddingSpotApprovalRequestListItem[];
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotApprovalRequestsResponse.
 * Use `create(ListBiddingSpotApprovalRequestsResponseSchema)` to create a new message.
 */
export const ListBiddingSpotApprovalRequestsResponseSchema: GenMessage<ListBiddingSpotApprovalRequestsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 3);

/**
 * @generated from message bffuser.v1.ListBiddingSpotPendingApprovalDatesRequest
 */
export type ListBiddingSpotPendingApprovalDatesRequest = Message<"bffuser.v1.ListBiddingSpotPendingApprovalDatesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotPendingApprovalDatesRequest.
 * Use `create(ListBiddingSpotPendingApprovalDatesRequestSchema)` to create a new message.
 */
export const ListBiddingSpotPendingApprovalDatesRequestSchema: GenMessage<ListBiddingSpotPendingApprovalDatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 4);

/**
 * @generated from message bffuser.v1.ListBiddingSpotPendingApprovalDatesResponse
 */
export type ListBiddingSpotPendingApprovalDatesResponse = Message<"bffuser.v1.ListBiddingSpotPendingApprovalDatesResponse"> & {
  /**
   * target_date 昇順、受渡日の重複なし。申請の無い受渡日は含まない。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotPendingApprovalDate dates = 1;
   */
  dates: BiddingSpotPendingApprovalDate[];
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotPendingApprovalDatesResponse.
 * Use `create(ListBiddingSpotPendingApprovalDatesResponseSchema)` to create a new message.
 */
export const ListBiddingSpotPendingApprovalDatesResponseSchema: GenMessage<ListBiddingSpotPendingApprovalDatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 5);

/**
 * @generated from message bffuser.v1.ListBiddingSpotOperationLogsRequest
 */
export type ListBiddingSpotOperationLogsRequest = Message<"bffuser.v1.ListBiddingSpotOperationLogsRequest"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotOperationLogsRequest.
 * Use `create(ListBiddingSpotOperationLogsRequestSchema)` to create a new message.
 */
export const ListBiddingSpotOperationLogsRequestSchema: GenMessage<ListBiddingSpotOperationLogsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 6);

/**
 * @generated from message bffuser.v1.ListBiddingSpotOperationLogsResponse
 */
export type ListBiddingSpotOperationLogsResponse = Message<"bffuser.v1.ListBiddingSpotOperationLogsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotOperationLog items = 1;
   */
  items: BiddingSpotOperationLog[];
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotOperationLogsResponse.
 * Use `create(ListBiddingSpotOperationLogsResponseSchema)` to create a new message.
 */
export const ListBiddingSpotOperationLogsResponseSchema: GenMessage<ListBiddingSpotOperationLogsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 7);

/**
 * @generated from message bffuser.v1.GetBiddingSpotApprovalRequestRequest
 */
export type GetBiddingSpotApprovalRequestRequest = Message<"bffuser.v1.GetBiddingSpotApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBiddingSpotApprovalRequestRequest.
 * Use `create(GetBiddingSpotApprovalRequestRequestSchema)` to create a new message.
 */
export const GetBiddingSpotApprovalRequestRequestSchema: GenMessage<GetBiddingSpotApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 8);

/**
 * @generated from message bffuser.v1.GetBiddingSpotApprovalRequestResponse
 */
export type GetBiddingSpotApprovalRequestResponse = Message<"bffuser.v1.GetBiddingSpotApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingSpotApprovalRequest;
};

/**
 * Describes the message bffuser.v1.GetBiddingSpotApprovalRequestResponse.
 * Use `create(GetBiddingSpotApprovalRequestResponseSchema)` to create a new message.
 */
export const GetBiddingSpotApprovalRequestResponseSchema: GenMessage<GetBiddingSpotApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 9);

/**
 * @generated from message bffuser.v1.CreateBiddingSpotApprovalRequestRequest
 */
export type CreateBiddingSpotApprovalRequestRequest = Message<"bffuser.v1.CreateBiddingSpotApprovalRequestRequest"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 2;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotBidInput spot_bids = 3;
   */
  spotBids: BiddingSpotBidInput[];

  /**
   * 操作元の業務ワークフローケース ID (画面を `?workflowId=` 付きで開いた経路)。 指定時、 backend は
   * 当該ケースが完了済 / 削除済なら FailedPrecondition で拒否する (AC-BSP-058 / AC-BSP-079 / AC-WFW-014)。
   * 省略 = ワークフロー非経由で、 拒否しない。
   *
   * @generated from field: optional string case_id = 4;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.CreateBiddingSpotApprovalRequestRequest.
 * Use `create(CreateBiddingSpotApprovalRequestRequestSchema)` to create a new message.
 */
export const CreateBiddingSpotApprovalRequestRequestSchema: GenMessage<CreateBiddingSpotApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 10);

/**
 * @generated from message bffuser.v1.CreateBiddingSpotApprovalRequestResponse
 */
export type CreateBiddingSpotApprovalRequestResponse = Message<"bffuser.v1.CreateBiddingSpotApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingSpotApprovalRequest;
};

/**
 * Describes the message bffuser.v1.CreateBiddingSpotApprovalRequestResponse.
 * Use `create(CreateBiddingSpotApprovalRequestResponseSchema)` to create a new message.
 */
export const CreateBiddingSpotApprovalRequestResponseSchema: GenMessage<CreateBiddingSpotApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 11);

/**
 * @generated from message bffuser.v1.UpdateBiddingSpotApprovalRequestRequest
 */
export type UpdateBiddingSpotApprovalRequestRequest = Message<"bffuser.v1.UpdateBiddingSpotApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 2;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotBidInput spot_bids = 3;
   */
  spotBids: BiddingSpotBidInput[];

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ (#8265)。
   *
   * @generated from field: optional string case_id = 5;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingSpotApprovalRequestRequest.
 * Use `create(UpdateBiddingSpotApprovalRequestRequestSchema)` to create a new message.
 */
export const UpdateBiddingSpotApprovalRequestRequestSchema: GenMessage<UpdateBiddingSpotApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 12);

/**
 * @generated from message bffuser.v1.UpdateBiddingSpotApprovalRequestResponse
 */
export type UpdateBiddingSpotApprovalRequestResponse = Message<"bffuser.v1.UpdateBiddingSpotApprovalRequestResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingSpotApprovalRequest;
};

/**
 * Describes the message bffuser.v1.UpdateBiddingSpotApprovalRequestResponse.
 * Use `create(UpdateBiddingSpotApprovalRequestResponseSchema)` to create a new message.
 */
export const UpdateBiddingSpotApprovalRequestResponseSchema: GenMessage<UpdateBiddingSpotApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 13);

/**
 * @generated from message bffuser.v1.DeleteBiddingSpotApprovalRequestRequest
 */
export type DeleteBiddingSpotApprovalRequestRequest = Message<"bffuser.v1.DeleteBiddingSpotApprovalRequestRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ (#8265)。
   *
   * @generated from field: optional string case_id = 3;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.DeleteBiddingSpotApprovalRequestRequest.
 * Use `create(DeleteBiddingSpotApprovalRequestRequestSchema)` to create a new message.
 */
export const DeleteBiddingSpotApprovalRequestRequestSchema: GenMessage<DeleteBiddingSpotApprovalRequestRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 14);

/**
 * @generated from message bffuser.v1.DeleteBiddingSpotApprovalRequestResponse
 */
export type DeleteBiddingSpotApprovalRequestResponse = Message<"bffuser.v1.DeleteBiddingSpotApprovalRequestResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBiddingSpotApprovalRequestResponse.
 * Use `create(DeleteBiddingSpotApprovalRequestResponseSchema)` to create a new message.
 */
export const DeleteBiddingSpotApprovalRequestResponseSchema: GenMessage<DeleteBiddingSpotApprovalRequestResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 15);

/**
 * @generated from message bffuser.v1.TransitionBiddingSpotApprovalStateRequest
 */
export type TransitionBiddingSpotApprovalStateRequest = Message<"bffuser.v1.TransitionBiddingSpotApprovalStateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.BiddingLifecycleAction action = 2;
   */
  action: BiddingLifecycleAction;

  /**
   * 差戻し理由。 action=REJECT のみ参照 (= REJECT 時 min_len=1 を usecase で検証、 他 action では無視)。
   * 上限は 100 文字 (input-character-limits.md の説明・メモ系 / approval-tasks.md の差戻しコメントと同値)。
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ。
   *
   * @generated from field: optional string case_id = 5;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingSpotApprovalStateRequest.
 * Use `create(TransitionBiddingSpotApprovalStateRequestSchema)` to create a new message.
 */
export const TransitionBiddingSpotApprovalStateRequestSchema: GenMessage<TransitionBiddingSpotApprovalStateRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 16);

/**
 * @generated from message bffuser.v1.TransitionBiddingSpotApprovalStateResponse
 */
export type TransitionBiddingSpotApprovalStateResponse = Message<"bffuser.v1.TransitionBiddingSpotApprovalStateResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingSpotApprovalRequest;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingSpotApprovalStateResponse.
 * Use `create(TransitionBiddingSpotApprovalStateResponseSchema)` to create a new message.
 */
export const TransitionBiddingSpotApprovalStateResponseSchema: GenMessage<TransitionBiddingSpotApprovalStateResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 17);

/**
 * @generated from message bffuser.v1.TransitionBiddingSpotDraftsRequest
 */
export type TransitionBiddingSpotDraftsRequest = Message<"bffuser.v1.TransitionBiddingSpotDraftsRequest"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotDraftTarget targets = 1;
   */
  targets: BiddingSpotDraftTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.TransitionBiddingSpotDraftsRequest.
 * Use `create(TransitionBiddingSpotDraftsRequestSchema)` to create a new message.
 */
export const TransitionBiddingSpotDraftsRequestSchema: GenMessage<TransitionBiddingSpotDraftsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 18);

/**
 * 承認申請・提出する下書きの申請セット 1 つ分の指定。
 *
 * @generated from message bffuser.v1.BiddingSpotDraftTarget
 */
export type BiddingSpotDraftTarget = Message<"bffuser.v1.BiddingSpotDraftTarget"> & {
  /**
   * 元の下書きの申請セット。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観ロック基準値 (= 現行 updated_at と一致必須)。 札の所属検査より先に照合する。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 承認申請・提出する札 (= この申請セットの札)。 申請セットの全札を指す時は分割せず、 申請セットごと遷移する。
   *
   * @generated from field: repeated string spot_bid_ids = 3;
   */
  spotBidIds: string[];

  /**
   * 申請セットの一部の札だけを指す時に必須。 全札を指す時は読まない (保存済みの承認モードで遷移する)。
   * 承認申請・提出する側 (元の申請セット) の承認モード。 Create / Update と同じ照合を受ける。
   *
   * @generated from field: optional bffuser.v1.BiddingApprovalMode approval_mode = 4;
   */
  approvalMode?: BiddingApprovalMode;

  /**
   * 一部の札だけを指す時に必須。 全札を指す時は読まない。 残りの札を移す新しい下書き側の承認モード。
   *
   * @generated from field: optional bffuser.v1.BiddingApprovalMode remaining_approval_mode = 5;
   */
  remainingApprovalMode?: BiddingApprovalMode;
};

/**
 * Describes the message bffuser.v1.BiddingSpotDraftTarget.
 * Use `create(BiddingSpotDraftTargetSchema)` to create a new message.
 */
export const BiddingSpotDraftTargetSchema: GenMessage<BiddingSpotDraftTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 19);

/**
 * @generated from message bffuser.v1.TransitionBiddingSpotDraftsResponse
 */
export type TransitionBiddingSpotDraftsResponse = Message<"bffuser.v1.TransitionBiddingSpotDraftsResponse"> & {
  /**
   * targets と同じ順。 承認申請・提出した側の遷移後の申請セット。 新しい下書きは返さない (一覧を読み直す)。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotApprovalRequest approval_requests = 1;
   */
  approvalRequests: BiddingSpotApprovalRequest[];
};

/**
 * Describes the message bffuser.v1.TransitionBiddingSpotDraftsResponse.
 * Use `create(TransitionBiddingSpotDraftsResponseSchema)` to create a new message.
 */
export const TransitionBiddingSpotDraftsResponseSchema: GenMessage<TransitionBiddingSpotDraftsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 20);

/**
 * 取下要求 (BFF)。
 *
 * @generated from message bffuser.v1.WithdrawBiddingSpotBidRequest
 */
export type WithdrawBiddingSpotBidRequest = Message<"bffuser.v1.WithdrawBiddingSpotBidRequest"> & {
  /**
   * 取り下げる札 (= BiddingSpotBid) の id。
   *
   * @generated from field: string spot_bid_id = 1;
   */
  spotBidId: string;

  /**
   * 楽観ロック基準値 (= 札が属する申請セットの updated_at)。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じ。
   *
   * @generated from field: optional string case_id = 3;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingSpotBidRequest.
 * Use `create(WithdrawBiddingSpotBidRequestSchema)` to create a new message.
 */
export const WithdrawBiddingSpotBidRequestSchema: GenMessage<WithdrawBiddingSpotBidRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 21);

/**
 * @generated from message bffuser.v1.WithdrawBiddingSpotBidResponse
 */
export type WithdrawBiddingSpotBidResponse = Message<"bffuser.v1.WithdrawBiddingSpotBidResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotApprovalRequest approval_request = 1;
   */
  approvalRequest?: BiddingSpotApprovalRequest;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingSpotBidResponse.
 * Use `create(WithdrawBiddingSpotBidResponseSchema)` to create a new message.
 */
export const WithdrawBiddingSpotBidResponseSchema: GenMessage<WithdrawBiddingSpotBidResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 22);

/**
 * 入札中の札の一括取下の要求 (BFF)。
 *
 * @generated from message bffuser.v1.WithdrawBiddingSpotBidsRequest
 */
export type WithdrawBiddingSpotBidsRequest = Message<"bffuser.v1.WithdrawBiddingSpotBidsRequest"> & {
  /**
   * 取り下げる札 (SpotBid)。 expected_updated_at は札が属する申請セットの updated_at。
   *
   * @generated from field: repeated bffuser.v1.BiddingBulkWithdrawTarget targets = 1;
   */
  targets: BiddingBulkWithdrawTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じで、
   * 拒否する時は札ごとの結果を返さずリクエスト全体を拒否する (AC-BSP-058 / AC-BSP-116)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingSpotBidsRequest.
 * Use `create(WithdrawBiddingSpotBidsRequestSchema)` to create a new message.
 */
export const WithdrawBiddingSpotBidsRequestSchema: GenMessage<WithdrawBiddingSpotBidsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 23);

/**
 * @generated from message bffuser.v1.WithdrawBiddingSpotBidsResponse
 */
export type WithdrawBiddingSpotBidsResponse = Message<"bffuser.v1.WithdrawBiddingSpotBidsResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.WithdrawBiddingSpotBidResult results = 1;
   */
  results: WithdrawBiddingSpotBidResult[];
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingSpotBidsResponse.
 * Use `create(WithdrawBiddingSpotBidsResponseSchema)` to create a new message.
 */
export const WithdrawBiddingSpotBidsResponseSchema: GenMessage<WithdrawBiddingSpotBidsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 24);

/**
 * @generated from message bffuser.v1.WithdrawBiddingSpotBidResult
 */
export type WithdrawBiddingSpotBidResult = Message<"bffuser.v1.WithdrawBiddingSpotBidResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.WithdrawBiddingSpotBidResult.outcome
   */
  outcome: {
    /**
     * 取下を受け付けた札 (取下処理中)。
     *
     * @generated from field: bffuser.v1.BiddingBulkWithdrawAccepted accepted = 2;
     */
    value: BiddingBulkWithdrawAccepted;
    case: "accepted";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingBulkWithdrawFailure failure = 3;
     */
    value: BiddingBulkWithdrawFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.WithdrawBiddingSpotBidResult.
 * Use `create(WithdrawBiddingSpotBidResultSchema)` to create a new message.
 */
export const WithdrawBiddingSpotBidResultSchema: GenMessage<WithdrawBiddingSpotBidResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 25);

/**
 * 通常入札 CSV のチェック要求 (BFF)。
 *
 * @generated from message bffuser.v1.CheckBiddingSpotNormalCsvRequest
 */
export type CheckBiddingSpotNormalCsvRequest = Message<"bffuser.v1.CheckBiddingSpotNormalCsvRequest"> & {
  /**
   * CSV ファイルの生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。 上限 20 MB
   * (spot-bid-normal-csv-import.md §4 / common.md、 ファイルサイズのみで制限し
   * 行数・削除件数の上限は設けない。 2026-09-25 PdM 決定)。
   *
   * @generated from field: bytes csv_content = 1;
   */
  csvContent: Uint8Array;

  /**
   * 投入 CSV ファイル名。任意。
   *
   * @generated from field: optional string csv_file_name = 2;
   */
  csvFileName?: string;

  /**
   * 使わない。 発注主体区分は CSV の列 (行ごと) に移った
   * (spot-bid-normal-csv-import.md §2 列 3)。 値を送っても無視する。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 3 [deprecated = true];
   * @deprecated
   */
  issuerType: LicenseType;

  /**
   * 使わない。 承認モードは確定時に行ごとのエリアの承認フロー設定から backend
   * が決める (spot-bid-normal-csv-import.md §4 / §5)。 値を送っても無視する。
   *
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 4 [deprecated = true];
   * @deprecated
   */
  approvalMode: BiddingApprovalMode;
};

/**
 * Describes the message bffuser.v1.CheckBiddingSpotNormalCsvRequest.
 * Use `create(CheckBiddingSpotNormalCsvRequestSchema)` to create a new message.
 */
export const CheckBiddingSpotNormalCsvRequestSchema: GenMessage<CheckBiddingSpotNormalCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 26);

/**
 * @generated from message bffuser.v1.CheckBiddingSpotNormalCsvResponse
 */
export type CheckBiddingSpotNormalCsvResponse = Message<"bffuser.v1.CheckBiddingSpotNormalCsvResponse"> & {
  /**
   * 引換券。 ApplyBiddingSpotNormalCsv に渡す。 有効期限 10 分・1 回消費。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 行ごとの差分プレビュー (CSV のデータ行順)。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotCsvRowResult rows = 2;
   */
  rows: BiddingSpotCsvRowResult[];

  /**
   * 新規行数 (= 取込対象)。
   *
   * @generated from field: int32 created_count = 3;
   */
  createdCount: number;

  /**
   * エラー行数。 > 0 なら確定は全体拒否される。
   *
   * @generated from field: int32 error_count = 4;
   */
  errorCount: number;

  /**
   * 受渡日ごとの新規行数 (AC-SPOT-014、CSV の受渡日初出順)。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotCsvDateCount date_counts = 5;
   */
  dateCounts: BiddingSpotCsvDateCount[];

  /**
   * 手数料自動考慮（スポット）が ON で手数料単価を取得できていない
   * (spot-bidding.md AC-BSP-004b)。 true の間、 client は確定ボタンを無効化する。
   *
   * @generated from field: bool fee_auto_consider_unavailable = 6;
   */
  feeAutoConsiderUnavailable: boolean;

  /**
   * 既存の札と重複する行の件数 (AC-SPOT-022)。 警告があっても確定は止めない。
   *
   * @generated from field: int32 duplicate_count = 7;
   */
  duplicateCount: number;
};

/**
 * Describes the message bffuser.v1.CheckBiddingSpotNormalCsvResponse.
 * Use `create(CheckBiddingSpotNormalCsvResponseSchema)` to create a new message.
 */
export const CheckBiddingSpotNormalCsvResponseSchema: GenMessage<CheckBiddingSpotNormalCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 27);

/**
 * @generated from message bffuser.v1.ApplyBiddingSpotNormalCsvRequest
 */
export type ApplyBiddingSpotNormalCsvRequest = Message<"bffuser.v1.ApplyBiddingSpotNormalCsvRequest"> & {
  /**
   * CheckBiddingSpotNormalCsvResponse.check_token。
   *
   * @generated from field: string check_token = 1;
   */
  checkToken: string;

  /**
   * 操作元の業務ワークフローケース ID (AC-BSP-079)。 Create の case_id と違い、 CSV は受渡日の混在を
   * 許すので、 ケースの対象日と同じ受渡日の行を含む時だけ、 ケースが完了済 / 削除済なら確定全体を
   * 拒否する。 含まなければ受渡日の不一致として拒否しない。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.ApplyBiddingSpotNormalCsvRequest.
 * Use `create(ApplyBiddingSpotNormalCsvRequestSchema)` to create a new message.
 */
export const ApplyBiddingSpotNormalCsvRequestSchema: GenMessage<ApplyBiddingSpotNormalCsvRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 28);

/**
 * @generated from message bffuser.v1.ApplyBiddingSpotNormalCsvResponse
 */
export type ApplyBiddingSpotNormalCsvResponse = Message<"bffuser.v1.ApplyBiddingSpotNormalCsvResponse"> & {
  /**
   * 実際に作成した札の件数。
   *
   * @generated from field: int32 created_count = 1;
   */
  createdCount: number;

  /**
   * 作成した承認依頼 (= 受渡日ごとに 1 件) の ID。
   *
   * @generated from field: repeated string approval_request_ids = 2;
   */
  approvalRequestIds: string[];
};

/**
 * Describes the message bffuser.v1.ApplyBiddingSpotNormalCsvResponse.
 * Use `create(ApplyBiddingSpotNormalCsvResponseSchema)` to create a new message.
 */
export const ApplyBiddingSpotNormalCsvResponseSchema: GenMessage<ApplyBiddingSpotNormalCsvResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 29);

/**
 * まとめて承認の要求 (BFF)。
 *
 * @generated from message bffuser.v1.ApproveBiddingSpotApprovalRequestsRequest
 */
export type ApproveBiddingSpotApprovalRequestsRequest = Message<"bffuser.v1.ApproveBiddingSpotApprovalRequestsRequest"> & {
  /**
   * 承認する案件 (申請セット)。
   *
   * @generated from field: repeated bffuser.v1.BiddingBulkApprovalTarget targets = 1;
   */
  targets: BiddingBulkApprovalTarget[];

  /**
   * 操作元の業務ワークフローケース ID。 扱いは CreateBiddingSpotApprovalRequestRequest.case_id と同じで、
   * 拒否する時は案件ごとの結果を返さずリクエスト全体を拒否する (AC-BSP-058 / AC-BSP-118)。
   *
   * @generated from field: optional string case_id = 2;
   */
  caseId?: string;
};

/**
 * Describes the message bffuser.v1.ApproveBiddingSpotApprovalRequestsRequest.
 * Use `create(ApproveBiddingSpotApprovalRequestsRequestSchema)` to create a new message.
 */
export const ApproveBiddingSpotApprovalRequestsRequestSchema: GenMessage<ApproveBiddingSpotApprovalRequestsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 30);

/**
 * @generated from message bffuser.v1.ApproveBiddingSpotApprovalRequestsResponse
 */
export type ApproveBiddingSpotApprovalRequestsResponse = Message<"bffuser.v1.ApproveBiddingSpotApprovalRequestsResponse"> & {
  /**
   * request の targets と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.ApproveBiddingSpotApprovalRequestResult results = 1;
   */
  results: ApproveBiddingSpotApprovalRequestResult[];
};

/**
 * Describes the message bffuser.v1.ApproveBiddingSpotApprovalRequestsResponse.
 * Use `create(ApproveBiddingSpotApprovalRequestsResponseSchema)` to create a new message.
 */
export const ApproveBiddingSpotApprovalRequestsResponseSchema: GenMessage<ApproveBiddingSpotApprovalRequestsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 31);

/**
 * @generated from message bffuser.v1.ApproveBiddingSpotApprovalRequestResult
 */
export type ApproveBiddingSpotApprovalRequestResult = Message<"bffuser.v1.ApproveBiddingSpotApprovalRequestResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from oneof bffuser.v1.ApproveBiddingSpotApprovalRequestResult.outcome
   */
  outcome: {
    /**
     * 承認した案件。 多段階承認の途中段なら承認待ち、 最終段なら承認済。
     *
     * @generated from field: bffuser.v1.BiddingBulkApprovalApproved approved = 2;
     */
    value: BiddingBulkApprovalApproved;
    case: "approved";
  } | {
    /**
     * @generated from field: bffuser.v1.BiddingSpotBulkApprovalFailure failure = 3;
     */
    value: BiddingSpotBulkApprovalFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.ApproveBiddingSpotApprovalRequestResult.
 * Use `create(ApproveBiddingSpotApprovalRequestResultSchema)` to create a new message.
 */
export const ApproveBiddingSpotApprovalRequestResultSchema: GenMessage<ApproveBiddingSpotApprovalRequestResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 32);

/**
 * @generated from message bffuser.v1.BiddingSpotBulkApprovalFailure
 */
export type BiddingSpotBulkApprovalFailure = Message<"bffuser.v1.BiddingSpotBulkApprovalFailure"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBulkApprovalFailureReason reason = 1;
   */
  reason: BiddingBulkApprovalFailureReason;

  /**
   * reason = BID_LIMIT_VIOLATION の時の詳細 (それ以外は UNSPECIFIED)。
   *
   * @generated from field: bffuser.v1.SpotBidWriteBlockedReason write_blocked_reason = 2;
   */
  writeBlockedReason: SpotBidWriteBlockedReason;
};

/**
 * Describes the message bffuser.v1.BiddingSpotBulkApprovalFailure.
 * Use `create(BiddingSpotBulkApprovalFailureSchema)` to create a new message.
 */
export const BiddingSpotBulkApprovalFailureSchema: GenMessage<BiddingSpotBulkApprovalFailure> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 33);

/**
 * field 番号は internalapi.v1.PreviewSpotBidFeeAdjustedPricesRequest と揃える。
 * organization_id (internalapi 版の 1) は認証情報から決まるため持たず、 1 は空ける。
 *
 * @generated from message bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesRequest
 */
export type PreviewBiddingSpotBidFeeAdjustedPricesRequest = Message<"bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesRequest"> & {
  /**
   * 希望価格から入札価格を算出したい行。 空でもよい (手数料自動考慮の状態と
   * desired_price_queries の結果だけを返す)。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotFeeAdjustedPriceQuery queries = 2;
   */
  queries: BiddingSpotFeeAdjustedPriceQuery[];

  /**
   * 保存済みの入札価格から希望価格を逆算したい行 (下書きの編集・再入札・複製の希望価格の初期値)。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotDesiredPriceQuery desired_price_queries = 3;
   */
  desiredPriceQueries: BiddingSpotDesiredPriceQuery[];
};

/**
 * Describes the message bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesRequest.
 * Use `create(PreviewBiddingSpotBidFeeAdjustedPricesRequestSchema)` to create a new message.
 */
export const PreviewBiddingSpotBidFeeAdjustedPricesRequestSchema: GenMessage<PreviewBiddingSpotBidFeeAdjustedPricesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 34);

/**
 * @generated from message bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesResponse
 */
export type PreviewBiddingSpotBidFeeAdjustedPricesResponse = Message<"bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesResponse"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotFeeAutoConsiderState fee_auto_consider = 1;
   */
  feeAutoConsider?: BiddingSpotFeeAutoConsiderState;

  /**
   * queries と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotFeeAdjustedPriceResult results = 2;
   */
  results: BiddingSpotFeeAdjustedPriceResult[];

  /**
   * desired_price_queries と同じ順・同じ件数。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotDesiredPriceResult desired_price_results = 3;
   */
  desiredPriceResults: BiddingSpotDesiredPriceResult[];
};

/**
 * Describes the message bffuser.v1.PreviewBiddingSpotBidFeeAdjustedPricesResponse.
 * Use `create(PreviewBiddingSpotBidFeeAdjustedPricesResponseSchema)` to create a new message.
 */
export const PreviewBiddingSpotBidFeeAdjustedPricesResponseSchema: GenMessage<PreviewBiddingSpotBidFeeAdjustedPricesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 35);

/**
 * @generated from message bffuser.v1.BiddingSpotSubmissionDuplicateTarget
 */
export type BiddingSpotSubmissionDuplicateTarget = Message<"bffuser.v1.BiddingSpotSubmissionDuplicateTarget"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: repeated string spot_bid_ids = 3;
   */
  spotBidIds: string[];
};

/**
 * Describes the message bffuser.v1.BiddingSpotSubmissionDuplicateTarget.
 * Use `create(BiddingSpotSubmissionDuplicateTargetSchema)` to create a new message.
 */
export const BiddingSpotSubmissionDuplicateTargetSchema: GenMessage<BiddingSpotSubmissionDuplicateTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 36);

/**
 * @generated from message bffuser.v1.CheckBiddingSpotSubmissionDuplicatesRequest
 */
export type CheckBiddingSpotSubmissionDuplicatesRequest = Message<"bffuser.v1.CheckBiddingSpotSubmissionDuplicatesRequest"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingSpotSubmissionDuplicateTarget targets = 2;
   */
  targets: BiddingSpotSubmissionDuplicateTarget[];
};

/**
 * Describes the message bffuser.v1.CheckBiddingSpotSubmissionDuplicatesRequest.
 * Use `create(CheckBiddingSpotSubmissionDuplicatesRequestSchema)` to create a new message.
 */
export const CheckBiddingSpotSubmissionDuplicatesRequestSchema: GenMessage<CheckBiddingSpotSubmissionDuplicatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 37);

/**
 * @generated from message bffuser.v1.CheckBiddingSpotSubmissionDuplicatesResponse
 */
export type CheckBiddingSpotSubmissionDuplicatesResponse = Message<"bffuser.v1.CheckBiddingSpotSubmissionDuplicatesResponse"> & {
  /**
   * @generated from field: int32 duplicate_count = 1;
   */
  duplicateCount: number;
};

/**
 * Describes the message bffuser.v1.CheckBiddingSpotSubmissionDuplicatesResponse.
 * Use `create(CheckBiddingSpotSubmissionDuplicatesResponseSchema)` to create a new message.
 */
export const CheckBiddingSpotSubmissionDuplicatesResponseSchema: GenMessage<CheckBiddingSpotSubmissionDuplicatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 38);

/**
 * 最新の成功した取り込みの警告。発注主体・一覧の絞り込みに依存しない。
 *
 * @generated from message bffuser.v1.GetBidImportStatusRequest
 */
export type GetBidImportStatusRequest = Message<"bffuser.v1.GetBidImportStatusRequest"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * false = スポット（通常・ブロックの合算）、 true = 時間前。
   *
   * @generated from field: bool intraday = 2;
   */
  intraday: boolean;
};

/**
 * Describes the message bffuser.v1.GetBidImportStatusRequest.
 * Use `create(GetBidImportStatusRequestSchema)` to create a new message.
 */
export const GetBidImportStatusRequestSchema: GenMessage<GetBidImportStatusRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 39);

/**
 * @generated from message bffuser.v1.GetBidImportStatusResponse
 */
export type GetBidImportStatusResponse = Message<"bffuser.v1.GetBidImportStatusResponse"> & {
  /**
   * @generated from field: bool has_unimported_bids = 1;
   */
  hasUnimportedBids: boolean;
};

/**
 * Describes the message bffuser.v1.GetBidImportStatusResponse.
 * Use `create(GetBidImportStatusResponseSchema)` to create a new message.
 */
export const GetBidImportStatusResponseSchema: GenMessage<GetBidImportStatusResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 40);

/**
 * ListSpotExecutionResultsRequest の mirror (organization_id は BFF が eauth から解決する)。
 *
 * @generated from message bffuser.v1.ListBiddingSpotExecutionResultsRequest
 */
export type ListBiddingSpotExecutionResultsRequest = Message<"bffuser.v1.ListBiddingSpotExecutionResultsRequest"> & {
  /**
   * @generated from field: google.type.Date from = 2;
   */
  from?: Date;

  /**
   * @generated from field: google.type.Date to = 3;
   */
  to?: Date;

  /**
   * @generated from field: repeated int32 komas = 4;
   */
  komas: number[];

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 5;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: repeated bfftypes.v1.Side sides = 6;
   */
  sides: Side[];

  /**
   * @generated from field: optional bffuser.v1.BiddingExecutionResultStatusSelection status_selection = 7;
   */
  statusSelection?: BiddingExecutionResultStatusSelection;

  /**
   * @generated from field: optional bffuser.v1.BiddingExecutionResultWorkflowSelection workflow_selection = 8;
   */
  workflowSelection?: BiddingExecutionResultWorkflowSelection;
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotExecutionResultsRequest.
 * Use `create(ListBiddingSpotExecutionResultsRequestSchema)` to create a new message.
 */
export const ListBiddingSpotExecutionResultsRequestSchema: GenMessage<ListBiddingSpotExecutionResultsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 41);

/**
 * @generated from message bffuser.v1.ListBiddingSpotExecutionResultsResponse
 */
export type ListBiddingSpotExecutionResultsResponse = Message<"bffuser.v1.ListBiddingSpotExecutionResultsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BiddingExecutionResultLine lines = 1;
   */
  lines: BiddingExecutionResultLine[];

  /**
   * @generated from field: int32 unarrived_bid_count = 2;
   */
  unarrivedBidCount: number;
};

/**
 * Describes the message bffuser.v1.ListBiddingSpotExecutionResultsResponse.
 * Use `create(ListBiddingSpotExecutionResultsResponseSchema)` to create a new message.
 */
export const ListBiddingSpotExecutionResultsResponseSchema: GenMessage<ListBiddingSpotExecutionResultsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_service, 42);

/**
 * @generated from enum bffuser.v1.BiddingSpotScreenSourceStatus
 */
export enum BiddingSpotScreenSourceStatus {
  /**
   * 未設定。consumer は取得成功とみなさず、書き込みを停止する。
   *
   * @generated from enum value: BIDDING_SPOT_SCREEN_SOURCE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * データ源の取得に成功した。
   *
   * @generated from enum value: BIDDING_SPOT_SCREEN_SOURCE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * データ源の取得に失敗した。consumer は部分表示を継続して書き込みを停止する。
   *
   * @generated from enum value: BIDDING_SPOT_SCREEN_SOURCE_STATUS_FETCH_FAILED = 2;
   */
  FETCH_FAILED = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotScreenSourceStatus.
 */
export const BiddingSpotScreenSourceStatusSchema: GenEnum<BiddingSpotScreenSourceStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_service, 0);

/**
 * スポット入札 承認依頼を frontend 向けに提供する service。
 *
 * @generated from service bffuser.v1.BiddingSpotService
 */
export const BiddingSpotService: GenService<{
  /**
   * 対象日・市場の、 未登録コードの下限で取り込まなかった札の有無。明細は返さない。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.GetBidImportStatus
   */
  getBidImportStatus: {
    methodKind: "unary";
    input: typeof GetBidImportStatusRequestSchema;
    output: typeof GetBidImportStatusResponseSchema;
  },
  /**
   * 一覧画面が必要とする spot / block 明細を 1 応答で返す。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.GetBiddingSpotScreen
   */
  getBiddingSpotScreen: {
    methodKind: "unary";
    input: typeof GetBiddingSpotScreenRequestSchema;
    output: typeof GetBiddingSpotScreenResponseSchema;
  },
  /**
   * 承認依頼の一覧。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotApprovalRequests
   */
  listBiddingSpotApprovalRequests: {
    methodKind: "unary";
    input: typeof ListBiddingSpotApprovalRequestsRequestSchema;
    output: typeof ListBiddingSpotApprovalRequestsResponseSchema;
  },
  /**
   * 入札締切前の受渡日ごとの承認申請中 (PENDING) の申請数 (AC-BSP-095)。明細は返さない。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotPendingApprovalDates
   */
  listBiddingSpotPendingApprovalDates: {
    methodKind: "unary";
    input: typeof ListBiddingSpotPendingApprovalDatesRequestSchema;
    output: typeof ListBiddingSpotPendingApprovalDatesResponseSchema;
  },
  /**
   * 受渡日の操作履歴 (AC-BSP-038)。 オペレーション履歴タブの source。 通常入札とブロック入札の両方を返す。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotOperationLogs
   */
  listBiddingSpotOperationLogs: {
    methodKind: "unary";
    input: typeof ListBiddingSpotOperationLogsRequestSchema;
    output: typeof ListBiddingSpotOperationLogsResponseSchema;
  },
  /**
   * 承認依頼 1 件 + 全 SpotBid 明細を取得。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.GetBiddingSpotApprovalRequest
   */
  getBiddingSpotApprovalRequest: {
    methodKind: "unary";
    input: typeof GetBiddingSpotApprovalRequestRequestSchema;
    output: typeof GetBiddingSpotApprovalRequestResponseSchema;
  },
  /**
   * 承認依頼を新規作成。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.CreateBiddingSpotApprovalRequest
   */
  createBiddingSpotApprovalRequest: {
    methodKind: "unary";
    input: typeof CreateBiddingSpotApprovalRequestRequestSchema;
    output: typeof CreateBiddingSpotApprovalRequestResponseSchema;
  },
  /**
   * 下書きの更新。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.UpdateBiddingSpotApprovalRequest
   */
  updateBiddingSpotApprovalRequest: {
    methodKind: "unary";
    input: typeof UpdateBiddingSpotApprovalRequestRequestSchema;
    output: typeof UpdateBiddingSpotApprovalRequestResponseSchema;
  },
  /**
   * 下書きの削除。 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.DeleteBiddingSpotApprovalRequest
   */
  deleteBiddingSpotApprovalRequest: {
    methodKind: "unary";
    input: typeof DeleteBiddingSpotApprovalRequestRequestSchema;
    output: typeof DeleteBiddingSpotApprovalRequestResponseSchema;
  },
  /**
   * 承認ワークフローの状態遷移 (= 承認申請 / 承認 / 差戻し / 申請取消 / JEPX 提出 / 差戻し後再編集 を action で指定)。
   * 共通 BiddingLifecycleAction を使うが、 spot では WITHDRAW を渡すと InvalidArgument。
   * 楽観ロック使用。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.TransitionBiddingSpotApprovalState
   */
  transitionBiddingSpotApprovalState: {
    methodKind: "unary";
    input: typeof TransitionBiddingSpotApprovalStateRequestSchema;
    output: typeof TransitionBiddingSpotApprovalStateResponseSchema;
  },
  /**
   * 下書きの申請セットから、 指定した札だけを承認申請または提出する (AC-BSP-007 / #7758)。
   * 各 target の action は遷移させる申請セットの承認モードから導く (要承認 → 承認申請、 承認なし・自動 → 提出)。
   * 一部の札だけを指定した時は、 指定した札を元の申請セットに残して遷移し、 残りを新しい下書きへ移す。
   * 全 targets を 1 transaction で処理し、 どれか 1 つでも拒否されたら何も変えない。 楽観ロック使用 (target ごと)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.TransitionBiddingSpotDrafts
   */
  transitionBiddingSpotDrafts: {
    methodKind: "unary";
    input: typeof TransitionBiddingSpotDraftsRequestSchema;
    output: typeof TransitionBiddingSpotDraftsResponseSchema;
  },
  /**
   * 入札中 (JEPX 送信済) の札 1 枚の取下 (AC-BSP-057)。 対象は申請セットではなく
   * 子札 1 枚なので TransitionBiddingSpotApprovalState とは別 RPC。
   * JEPX への取消送信は非同期で、 成立まで札は「取下処理中」 に留まる (AC-BSP-057b)。
   * 楽観ロック使用 (基準値は札が属する申請セットの updated_at)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.WithdrawBiddingSpotBid
   */
  withdrawBiddingSpotBid: {
    methodKind: "unary";
    input: typeof WithdrawBiddingSpotBidRequestSchema;
    output: typeof WithdrawBiddingSpotBidResponseSchema;
  },
  /**
   * 入札中の札の一括取下 (AC-BSP-116)。 件数の上限は無い。 1 トランザクションでまとめて取下処理中にし、
   * 取下できなかった札は理由を results に返す。 error 応答ならどの札も取り下げていない (通信の失敗では
   * 結果不明なので一覧を読み直す。 internalapi の同名 RPC 参照)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.WithdrawBiddingSpotBids
   */
  withdrawBiddingSpotBids: {
    methodKind: "unary";
    input: typeof WithdrawBiddingSpotBidsRequestSchema;
    output: typeof WithdrawBiddingSpotBidsResponseSchema;
  },
  /**
   * 通常入札 CSV のチェック (= 構文 + 業務検証 + 差分プレビュー、 副作用なし)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.CheckBiddingSpotNormalCsv
   */
  checkBiddingSpotNormalCsv: {
    methodKind: "unary";
    input: typeof CheckBiddingSpotNormalCsvRequestSchema;
    output: typeof CheckBiddingSpotNormalCsvResponseSchema;
  },
  /**
   * 通常入札 CSV の確定 (= check_token を引き換えて承認依頼を作成)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ApplyBiddingSpotNormalCsv
   */
  applyBiddingSpotNormalCsv: {
    methodKind: "unary";
    input: typeof ApplyBiddingSpotNormalCsvRequestSchema;
    output: typeof ApplyBiddingSpotNormalCsvResponseSchema;
  },
  /**
   * まとめて承認 (AC-BSP-118)。 件数の上限は無い。 1 トランザクションでまとめて承認し、 承認できなかった
   * 案件は理由を results に返す。 error 応答ならどの案件も承認していない (通信の失敗では結果不明なので
   * 一覧を読み直す。 internalapi の同名 RPC 参照)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ApproveBiddingSpotApprovalRequests
   */
  approveBiddingSpotApprovalRequests: {
    methodKind: "unary";
    input: typeof ApproveBiddingSpotApprovalRequestsRequestSchema;
    output: typeof ApproveBiddingSpotApprovalRequestsResponseSchema;
  },
  /**
   * 手数料自動考慮 (スポット) の状態と、 希望価格から算出する入札価格 (AC-BSP-004b / AC-BSP-106)、
   * 保存済みの入札価格から逆算する希望価格を返す読み取り。 作成・下書きの更新
   * (BiddingSpotBidInput.fee_auto_consider) は同じ算出で入札価格を決める。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.PreviewBiddingSpotBidFeeAdjustedPrices
   */
  previewBiddingSpotBidFeeAdjustedPrices: {
    methodKind: "unary";
    input: typeof PreviewBiddingSpotBidFeeAdjustedPricesRequestSchema;
    output: typeof PreviewBiddingSpotBidFeeAdjustedPricesResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.BiddingSpotService.CheckBiddingSpotSubmissionDuplicates
   */
  checkBiddingSpotSubmissionDuplicates: {
    methodKind: "unary";
    input: typeof CheckBiddingSpotSubmissionDuplicatesRequestSchema;
    output: typeof CheckBiddingSpotSubmissionDuplicatesResponseSchema;
  },
  /**
   * 受渡日の期間の約定結果 CSV の行と、 約定結果が未着の札の件数を返す (AC-BSP-115)。
   *
   * @generated from rpc bffuser.v1.BiddingSpotService.ListBiddingSpotExecutionResults
   */
  listBiddingSpotExecutionResults: {
    methodKind: "unary";
    input: typeof ListBiddingSpotExecutionResultsRequestSchema;
    output: typeof ListBiddingSpotExecutionResultsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_bidding_spot_service, 0);

